<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="id ? '编辑项目' : '新增项目'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 项目名称 -->
      <a-form-item
        label="项目名称"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.name"
        />
      </a-form-item>
      <!-- 分成比例 -->
      <a-form-item
        label="分成比例"
        name="cash_rate"
        :rules="[{ required: true, validator: validatorScale }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.cash_rate"
          suffix="%"
        />
      </a-form-item>
      <!-- 项目属性 -->
      <a-form-item
        label="项目属性"
        name="type"
        :rules="[{ required: true }]"
      >
        <a-select
          v-model:value="formState.type"
          placeholder="请选择"
          :filter-option="filterOption"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option
            v-for="item in ProjectAttrs"
            :key="`${item.value}-${item.text}`"
            :value="item.value"
          >
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 项目类型 -->
      <a-form-item
        label="项目类型"
        name="project_type"
        :rules="[{ required: true }]"
      >
        <a-radio-group v-model:value="formState.project_type">
          <a-radio :style="radioStyle" :value="0">普通小程序</a-radio>
          <!-- <a-radio :style="radioStyle" :value="1">穿山甲小程序</a-radio> -->
        </a-radio-group>
      </a-form-item>
      <!-- request -->
      <a-form-item
        v-if="formState.project_type === 1"
        label="request"
        name="csj_request"
        :rules="[{ required: true }]"
      >
        <a-textarea
          placeholder="api1.csj.com&#10;api2.csj.com"
          v-model:value="formState.csj_request"
          :rows="3"
        />
      </a-form-item>
      <!-- download -->
      <a-form-item
        v-if="formState.project_type === 1"
        label="download"
        name="csj_download"
      >
        <a-textarea
          placeholder="api1.csj.com&#10;api2.csj.com"
          v-model:value="formState.csj_download"
          :rows="3"
        />
      </a-form-item>
      <!-- upload -->
      <a-form-item
        v-if="formState.project_type === 1"
        label="upload"
        name="csj_upload"
      >
        <a-textarea
          placeholder="api1.csj.com&#10;api2.csj.com"
          v-model:value="formState.csj_upload"
          :rows="3"
        />
      </a-form-item>
      <!-- socket -->
      <a-form-item
        v-if="formState.project_type === 1"
        label="socket"
        name="csj_socket"
      >
        <a-textarea
          placeholder="api1.csj.com&#10;api2.csj.com"
          v-model:value="formState.csj_socket"
          :rows="3"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import { projectEdit } from '@/api/system'
import Pub from '@/utils/public'
import { ProjectAttrs } from '@/utils/constant'

// emit
const emit = defineEmits(['success'])
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// id
let id = ref(null)
// 表单
let formState = reactive({
  // 名称
  name: undefined,
  // 比例
  cash_rate: undefined,
  // 项目属性
  type: undefined,
  // 项目类型
  project_type: 0,
  // // [穿山甲] download 域名配置
  // csj_download: undefined,
  // // [穿山甲] request 域名配置
  // csj_request: undefined,
  // // [穿山甲] socket 域名配置
  // csj_socket: undefined,
  // // [穿山甲] upload 域名配置
  // csj_upload: undefined
})


// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // 赋值
  nextTick(() => {
    // id
    id.value = params.id
    // name
    formState.name = params.name
    // 分成比例
    formState.cash_rate = params.cash_rate
    // 项目属性
    formState.type = params.type
    // 项目类型
    formState.project_type = params.project_type || 0
    // // [穿山甲]
    // formState.csj_download = (params.csj_download || []).join('\n')
    // formState.csj_request = (params.csj_request || []).join('\n')
    // formState.csj_socket = (params.csj_socket || []).join('\n')
    // formState.csj_upload = (params.csj_upload || []).join('\n')
  })
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    // 重置
    RefForm.value.resetFields()
    id.value = undefined
    visible.value = false
  }
}

// 效验 - 分成比例
function validatorScale (rule, value) {
  if (!value) {
    return Promise.reject('请输入${label}')
  } else if (!Pub.REG_IS_NUMBER(value)) {
    return Promise.reject('必须为正数')
  } else if (Pub.CHECK_NUMBER_DECIMAL(value, 2)) {
    return Promise.reject('最多 2 位小数')
  }
  return Promise.resolve()
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const params = {
      id: id.value,
      ...formState,
      // // [穿山甲]
      // csj_download: formState.csj_download ? formState.csj_download.split('\n') : [],
      // csj_request: formState.csj_request ? formState.csj_request.split('\n') : [],
      // csj_socket: formState.csj_socket ? formState.csj_socket.split('\n') : [],
      // csj_upload: formState.csj_upload ? formState.csj_upload.split('\n') : []
    }
    projectEdit(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        // 更新父组件
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
  width: 118px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.upload-item-select {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
.upload-item-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 18px;
  color: #8D8D8D;
  cursor: pointer;
  opacity: 0;
}
.form-upload-item:hover .upload-item-delete {
  opacity: 1;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
</style>